import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/vip-banner.gif';
const _withScopeId = n => (_pushScopeId("data-v-f62c477c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "会员中心"
}, null, -1));
import ProjectTop from './detail/ProjectDetailTop.vue';
import ProjectDetailDetail from './detail/ProjectDetailDetail.vue';
import ProjectDetailDetailRight from './detail/ProjectDetailDetailRight.vue';
import { onMounted, ref } from "vue";
import { XiaoniuFrontedControllerService } from "../../../generated/services/XiaoniuFrontedControllerService";
import { useRoute } from "vue-router";
import { SysDictDataControllerService } from "../../../generated";
import { useLoginUserStore } from "@/store/loginUser";
export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectDetail',
  setup(__props) {
    const dicType = ref("project_type");
    const dictList = ref([]);
    const route = useRoute();
    const projectDetail = ref({});
    const projectViewCount = ref(0);
    const projectBuyCount = ref(0);
    const useloginUser = useLoginUserStore();
    const projectTopFiveList = ref([]);
    const getProjectDetail = async () => {
      const id = Number(route.params.id);
      const res = await XiaoniuFrontedControllerService.getInfoUsingGet18(id);
      projectDetail.value = res.data;
    };
    //添加浏览量
    const putProjectView = async () => {
      const projectId = Number(route.params.id);
      if (useloginUser.isLogin) {
        await XiaoniuFrontedControllerService.addProjectViewUsingPost(projectId);
      }
      await getProjectViewCount();
    };
    const getProjectTopFive = async () => {
      const res = await XiaoniuFrontedControllerService.topFiveProjectUsingPost();
      if (res.code === 200) {
        projectTopFiveList.value = res.data;
      }
    };
    const getProjectViewCount = async () => {
      const projectId = Number(route.params.id);
      const res = await XiaoniuFrontedControllerService.getProjectViewUsingPost(projectId);
      projectViewCount.value = res.data;
    };
    const getProjectBuyCount = async () => {
      const projectId = Number(route.params.id);
      const res = await XiaoniuFrontedControllerService.getCountProjectBuy(projectId);
      projectBuyCount.value = res.data;
    };
    const getSysDicType = () => {
      //获取字典数据
      SysDictDataControllerService.dictTypeUsingGet(dicType.value).then(res => {
        if (res.code === 200) {
          dictList.value = res.data;
        }
      });
    };
    onMounted(() => {
      getProjectDetail();
      getSysDicType();
      putProjectView();
      getProjectBuyCount();
      getProjectTopFive();
    });
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_RouterLink = _resolveComponent("RouterLink");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          sm: 24,
          md: 24,
          style: {
            "transition": "all .5s ease-out"
          }
        }, {
          default: _withCtx(() => [_createVNode(ProjectTop, {
            "project-detail": projectDetail.value,
            "dict-list": dictList.value,
            "project-view-count": projectViewCount.value,
            "project-buy-count": projectBuyCount.value
          }, null, 8, ["project-detail", "dict-list", "project-view-count", "project-buy-count"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          sm: 24,
          md: 24,
          style: {
            "transition": "all .5s ease-out",
            "margin-bottom": "30px"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_RouterLink, {
            to: {
              path: '/member'
            }
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          })])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        gutter: 30
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          sm: 24,
          md: 16,
          style: {
            "transition": "all .5s ease-out",
            "margin-bottom": "30px"
          }
        }, {
          default: _withCtx(() => [_createVNode(ProjectDetailDetail, {
            "project-detail": projectDetail.value
          }, null, 8, ["project-detail"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          sm: 24,
          md: 8
        }, {
          default: _withCtx(() => [_createVNode(ProjectDetailDetailRight, {
            "project-top-five-list": projectTopFiveList.value
          }, null, 8, ["project-top-five-list"])]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
});